<template>
  <small class="text-sm font-bold tracking-normal text-gray-900">
    <slot />
  </small>
</template>
